import React, { useEffect, useState } from "react";
import axios from "axios";
import "./csstestimonial.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import { useTranslation } from "react-i18next";
import Modal from "../Modal/Modal";
import { baseURL } from "../../App";
import SkeletonLoader from "../Skeleton/SkeletonLoader";

export const Testimonial = () => {
  const { t } = useTranslation();
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [newTestimonial, setNewTestimonial] = useState({
    testimonial: "",
    name: "",
    rating: 0,
  });
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/testimonials`);
        // console.log("Fetched Testimonials:", response.data);
        const sortedTestimonials = [...response.data].sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setTestimonials(sortedTestimonials);
      } catch (err) {
        setError("Error fetching testimonials");
        console.error("Error fetching testimonials:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  const handleRatingSelect = (rating) => {
    setNewTestimonial((prev) => ({ ...prev, rating }));
  };

  const handleSubmit = async (e) => {
    // console.log("Submitting:", newTestimonial);
    try {
      await axios.post(`${baseURL}/api/testimonials`, newTestimonial);
      setNewTestimonial({ testimonial: "", name: "", rating: 0 });

      setModalOpen(false);
      const response = await axios.get(`${baseURL}/api/testimonials`);
      setTestimonials(response.data);
    } catch (err) {
      console.error("Error submitting testimonial:", err);
    }
  };

  if (loading) {
    return (
      <section id="testimonial">
        <h5>{t("testimonials.sub_titles")}</h5>
        <h2>{t("testimonials.title")}</h2>
        <SkeletonLoader type="grid" count={3} />
      </section>
    );
  }
  if (error) return <p>{error}</p>;

  const getInitials = (name) => {
    if (!name || typeof name !== "string") return "";
    return name
      .split(" ")
      .map((part) => part.charAt(0).toUpperCase())
      .join("");
  };

  const randomColor = () => {
    const colors = [
      "#51835c",
      "#33FF57",
      "#3357FF",
      "#FF33A1",
      "#FFC300",
      "#045c64",
      "#16088f",
      "#960396",
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  return (
    <section id="testimonial">
      <h5>{t("testimonials.sub_titles")}</h5>
      <h2>{t("testimonials.title")}</h2>
      <Modal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onSubmit={handleSubmit}
        testimonial={newTestimonial}
        setTestimonial={setNewTestimonial}
        onRatingSelect={handleRatingSelect}
        rating={newTestimonial.rating}
      />
      <Swiper
        className="container testimonials_container"
        modules={[EffectCoverflow, Pagination, Navigation]}
        pagination={{ clickable: true }}
        navigation
        spaceBetween={20}
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        // slidesPerView={'auto'}
        // slidesPerView={3}
        breakpoints={{
          // For mobile devices
          320: {
            slidesPerView: 1,
          },
          // For tablets
          640: {
            slidesPerView: 2,
          },
          // For larger screens
          1024: {
            slidesPerView: 3,
          },
        }}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
      >
        {testimonials.map(({ id, testimonial, name, rating, createdAt }) => (
          <SwiperSlide key={id} className="testimonial">
            <div className="testimonial-container">
              <div className="client_avatar">
                <div
                  className="avatar"
                  style={{ backgroundColor: randomColor() }}
                >
                  {getInitials(name)}
                </div>
              </div>
              <h5 className="client_name"> {name} </h5>
              <small className="client_review"> {testimonial} </small>
              <div className="client_rating">
                {Array.from({ length: 5 }, (_, index) => (
                  <span
                    key={index}
                    className={`star ${
                      index < Math.floor(rating)
                        ? "filled"
                        : index + 0.5 === rating
                        ? "half"
                        : ""
                    }`}
                  >
                    {index < Math.floor(rating)
                      ? "★"
                      : index + 0.5 === rating
                      ? "★"
                      : "☆"}
                  </span>
                ))}
              </div>
              <small className="client_date">
                {new Date(createdAt).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })}{" "}
                -{" "}
                {new Date(createdAt).toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </small>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="review">
        <button className="btn btnPrimary" onClick={() => setModalOpen(true)}>
          {t("testimonials.btn")}
        </button>
      </div>
    </section>
  );
};

export default Testimonial;
